import styles from '@/common/containers/ModuleOverview/styles.less';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import CopyrightSup from '@/common/components/CopyrightSup';

const Asset = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.blockBody}>
      <h4 className={styles.contentTitle}>
        {t('Assets tasks module overview')}
      </h4>
      <div className={styles.contentDescription}>
        <p>
          <Trans
            i18nKey="<1>Assets tasks</1> will assist with managing (i.e. transfer, sell, distribute, etc) assets that were owned by the decedent at the time of their death."
            components={{ 1: <b /> }}
          />
        </p>
        <br />
        <ul>
          <ol>
            {t(
              '“Assets” are physical or digital items of value the decedent owned and/or were registered in the decedent’s name at the time of death. Assets are categorized as: Real Property; Vehicles; Firearms; Valuables; Digital Assets; and, Livestock.'
            )}
          </ol>
        </ul>
      </div>
      <h3 className={styles.contentSubTitle}>{t('Instructions')}</h3>
      <div className={styles.contentStepper}>
        <Stepper orientation="vertical">
          <Step active>
            <StepLabel className={styles.contentStep}>
              <Trans
                i18nKey="Complete the “<1>Assets tasks</1> Questionnaire”. (This will identify and generate an “<2>Assets tasks</2> List”)"
                components={{ 1: <b />, 2: <b /> }}
              />
            </StepLabel>
          </Step>
          <Step active>
            <StepLabel className={styles.contentStep}>
              <Trans
                i18nKey="Start completing the “<1>Assets tasks</1> List”."
                components={{ 1: <b /> }}
              />
            </StepLabel>
          </Step>
        </Stepper>
      </div>
      <h3 className={styles.contentSubTitle}>{t('Timeframe')}</h3>
      <div className={styles.contentTimeFrame}>
        <ul>
          <ol>
            <Trans
              i18nKey="<1>Assets tasks</1> should be started as soon as possible after confirming (through the <2>Legal tasks</2>) that the Executor has the legal authority to complete the various estate management tasks."
              components={{ 1: <b />, 2: <b /> }}
            />
          </ol>
        </ul>
      </div>
      <div className={styles.contentNoteWrap}>
        <div className="note">
          <Trans
            i18nKey="You can conduct <1>Main tasks</1> concurrent with <2>Assets tasks</2> to expedite the PAEM<3></3> process."
            components={{ 1: <b />, 2: <b />, 3: <CopyrightSup /> }}
          />
        </div>
      </div>
    </div>
  );
};

export default Asset;
